module.exports = __webpack_public_path__ + "static/media/slider1-2.dd0cb0b8.png";